export const ATTACHMENT_ACCEPT =
  '.pdf,.jpg,.jpeg,.png,.heic,.heif,application/pdf,image/jpeg,image/png,image/heic,image/heif';

export const MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024;

const MIME_BY_EXTENSION: Record<string, string> = {
  '.pdf': 'application/pdf',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.heic': 'image/heic',
  '.heif': 'image/heif',
};

const ALLOWED_EXTENSIONS = Object.keys(MIME_BY_EXTENSION);

export interface AttachmentValidationResult {
  valid: boolean;
  errorKey?: string;
}

const getExtension = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf('.');
  return dotIndex === -1 ? '' : fileName.slice(dotIndex).toLowerCase();
};

// Files restored from a saved deduction/invoice only carry a name, so the type
// has to be derived from the extension rather than read off the File.
export const getMimeTypeFromFileName = (fileName: string): string =>
  MIME_BY_EXTENSION[getExtension(fileName)] || 'application/octet-stream';

// Validation is deliberately extension-based. Browsers derive File.type from the
// OS mapping, which reports 'application/octet-stream' for .heic/.heif on
// machines without the HEIF codec installed - a MIME check rejects valid photos.
export const validateAttachment = (file: File): AttachmentValidationResult => {
  const extension = getExtension(file.name);

  if (!ALLOWED_EXTENSIONS.includes(extension)) {
    return { valid: false, errorKey: 'UPLOAD_ONLY_PDF' };
  }

  if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return { valid: false, errorKey: 'FILE_SIZE_LESS_THAN_1MB' };
  }

  return { valid: true };
};
